/**
 * Ensures a provided url is prefixed with https://
 */
export const normalizeUrl = (url = '') =>
  url.replace(/^(https?:\/\/)?/, 'https://');
